(ns frontend.ui.style.theme.core
  (:require
   [common.themes.registry :as theme-registry]
   [frontend.db :as db]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [shadow.resource :as rc]))

(def theme-state (r/atom :base))

(defn get-theme
  []
  (or @theme-state :base))

(defn innovestor-theme?
  []
  (= (get-theme) :theme.lp-portal/innovestor))

(defn set-theme!
  [id]
  (let [coordinates [:tenant/reporting-theme]]
    (reset! theme-state id)
    (swap! db/tenant assoc-in [:tenant/reporting-theme] id)
    (-> (swap! db/tenant assoc-in coordinates id)
        (get-in coordinates))))

;; To declare a new theme:
;; - copy file `./base.cljs` into a brand new one
;; - update its values
;;   - adding new keys serves no purpose
;;   - the most interesting keys are the three `colors/brand-%`
;; - declare a new entry with identical values in the following map

(def ^:private themes
  "`:base` is the default theme set in `frontend.db/app-state`
  at `[:session :theme-id]`"
  theme-registry/theme-lookup)


(defn border-radius
  [border-radius-id]
  (get-in themes [(get-theme) :border-radiuses border-radius-id]))

(defn border-width
  [border-width-id]
  (get-in themes [(get-theme) :border-widths border-width-id]))

(def ^:private hex-re
  #"(^#(?:[0-9a-fA-F]{3,4}){1,2}$|transparent)")

(def ^:private css-color-re
  #"transparent|(#?([a-fA-F\d]{3,4}|[a-fA-F\d]{6}|[a-fA-F\d]{8})|rgb\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d)\)|rgba\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|0?\.\d*|1(\.0)?)\)|hsl\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%\)|hsla\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%,(0?\.\d*|1(\.0)?)\))$")

(defn color
  [color-id]
  ;; Just checking we respect the new format for `color-id`: vector and not just keyword
  {:pre [(vector? color-id)]}
  ;; Commenting this out as it crashes the whole application
  ;; :post [(and (some? %) (re-matches hex-re %))]

  (let [palette-color-kw (get-in themes (concat [(get-theme) :colors] color-id))
        theme-path (concat [(get-theme) :palette] [palette-color-kw])
        hex-color (get-in themes theme-path)]
    #_(js/console.log "COLOR :  " (get-theme) "." color-id " > " hex-color)
    (when (and (not (session/prod?))
               (or (nil? hex-color)
                   (nil? (re-matches css-color-re hex-color))))
      (js/console.error ">> Bad color key "
                        (get-theme)
                        color-id
                        hex-color
                        " " palette-color-kw
                        "\n " themes))
    hex-color))

(defn palette-value
  [color-id]
  (get-in themes [(get-theme) :palette color-id]))

(defn colors
  [color-path]
  {:pre [(vector? color-path)]}
  (let [palette-color-list (get-in themes (concat [(get-theme) :colors] color-path))
        hex-colors (->> palette-color-list
                        (mapv (fn [palette-color-kw]
                                (let [theme-path (concat [(get-theme) :palette] [palette-color-kw])
                                      hex-color (get-in themes theme-path)]
                                  (when (or (nil? hex-color)
                                            (nil? (re-matches css-color-re hex-color)))
                                    (js/console.error ">> Bad color key "
                                                      (get-theme)
                                                      color-path
                                                      " > "
                                                      hex-color
                                                      " " palette-color-kw
                                                      "\n " themes))
                                  hex-color))))]
    hex-colors))

(defn edge-size
  [edge-size-id]
  (get-in themes [(get-theme) :edge-sizes edge-size-id]))

(defn font-weight
  [font-weight-id]
  (get-in themes [(get-theme) :font-weights font-weight-id]))

(defn font-families
  [font-families-id]
  (get-in themes [(get-theme) :font-families font-families-id]))

(defn text-size
  ([text-id]
   (get-in themes [(get-theme) :text-sizes text-id]))
  ([text-id selector]
   (get-in themes [(get-theme) :text-sizes text-id selector])))

(def base-svg
  (rc/inline "./svg/base.svg"))

(def capman-logo-light-svg
  (rc/inline "./svg/capman-logo-light-gray.svg"))

(def reindeer-logo-light-svg
  (rc/inline "./svg/reindeerpartners-logo-light-gray.svg"))

(def capman-logo-svg
  (rc/inline "./svg/capman-logo.svg"))

(def capman-logo-black-svg
  (rc/inline "./svg/capman-logo-black.svg"))

(def voima-logo-svg
  (rc/inline "./svg/voima-logo.svg"))

(def voima-logo-with-name-svg
  (rc/inline "./svg/voima-logo-with-name.svg"))

(def sparkmind-logo-svg
  (rc/inline "./svg/sparkmind-logo-black.svg"))

(def sparkmind-logo-light-svg
  (rc/inline "./svg/sparkmind-logo-white.svg"))

(def innovestor-logo-svg
  (rc/inline "./svg/innovestor-dark.svg"))

(def innovestor-logo-light-svg
  (rc/inline "./svg/innovestor.svg"))

(def nest-capital-logo-black
  (rc/inline "./svg/nest-capital-logo-black.svg"))

(def nest-capital-logo-white
  (rc/inline "./svg/nest-capital-logo-white.svg"))

(def sponsor-capital-logo
  (rc/inline "./svg/transparent.svg"))                                                              ;;TODO change to real logo if needed

(def lifeline-logo-white-svg
  (rc/inline "./svg/lifeline_raster_logo_white.svg"))

(def lifeline-logo-black-svg
  (rc/inline "./svg/lifeline_raster_logo_black.svg"))

(defn svg-logo
  []
  (case (get-theme)
    :base
    base-svg
    :theme.lp-portal/capman
    capman-logo-svg
    :theme.lp-portal/reindeer-partners
    reindeer-logo-light-svg
    :theme.lp-portal/voima
    voima-logo-svg
    :theme.lp-portal/sparkmind
    sparkmind-logo-svg
    :theme.lp-portal/innovestor
    innovestor-logo-svg
    :theme.lp-portal/sponsor-capital
    sponsor-capital-logo
    :theme.lp-portal/lifeline
    lifeline-logo-black-svg
    base-svg))

(defn svg-logo-light
  []
  (case (get-theme)
    :base
    base-svg
    :theme.lp-portal/capman
    capman-logo-light-svg
    :theme.lp-portal/reindeer-partners
    reindeer-logo-light-svg
    :theme.lp-portal/voima
    voima-logo-with-name-svg
    :theme.lp-portal/sparkmind
    sparkmind-logo-light-svg
    :theme.lp-portal/innovestor
    innovestor-logo-light-svg
    :theme.lp-portal/sponsor-capital
    sponsor-capital-logo
    :theme.lp-portal/lifeline
    lifeline-logo-white-svg
    base-svg))
